import { render, staticRenderFns } from "./VEmployerVisaCases.vue?vue&type=template&id=0e0673df&scoped=true&lang=pug"
import script from "./VEmployerVisaCases.vue?vue&type=script&lang=ts"
export * from "./VEmployerVisaCases.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0673df",
  null
  
)

export default component.exports